import { Icon, IconProps } from "@chakra-ui/react";

export function MenuHintIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M19.5 4C19.5 3.72386 19.2761 3.5 19 3.5H5C4.72386 3.5 4.5 3.72386 4.5 4V20C4.5 20.2761 4.72386 20.5 5 20.5H19C19.2761 20.5 19.5 20.2761 19.5 20V4ZM20.5 20C20.5 20.8284 19.8284 21.5 19 21.5H5C4.17157 21.5 3.5 20.8284 3.5 20V4C3.5 3.17157 4.17157 2.5 5 2.5H19C19.8284 2.5 20.5 3.17157 20.5 4V20Z"
        fill="currentColor"
      />
      <circle cx="17.5" cy="14.5" r="0.5" fill="currentColor" />
      <circle cx="17.5" cy="12.5" r="0.5" fill="currentColor" />
      <circle cx="17.5" cy="16.5" r="0.5" fill="currentColor" />
      <rect x="6" y="18" width="12" height="1" rx="0.5" fill="currentColor" />
      <rect x="6" y="5" width="3" height="1" rx="0.5" fill="currentColor" />
      <rect x="6" y="7" width="3" height="1" rx="0.5" fill="currentColor" />
      <rect x="6" y="9" width="2" height="1" rx="0.5" fill="currentColor" />
      <rect
        x="18"
        y="5"
        width="2"
        height="1"
        rx="0.5"
        transform="rotate(90 18 5)"
        fill="currentColor"
      />
    </Icon>
  );
}
